module.exports = __webpack_public_path__ + "files/bc56e74de7de4b3cc9b5cc90647f436d.png";